export default __webpack_public_path__ + "static/media/maestro.ea4d28f3.svg";